import { render, staticRenderFns } from "./FunctionBoxAccounts.vue?vue&type=template&id=03939d90"
import script from "./FunctionBoxAccounts.vue?vue&type=script&lang=js"
export * from "./FunctionBoxAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports